export default {
    namespaced: true,
    detection_event: {
      title: "eventos|eventos",
      event_type: "tipo de evento",
      event_created_at: "Fecha de creación de evento",
      provider: "proveedor",
      data: "datos",
      metadata:"metadata",
      media: "imagen",
      pause: 'Pause',
      play: 'Reproducir',
      playing: 'Reproduciendo',
      update: 'Actualizar',
      ms_title: "ms eventos|ms eventos",
      export_excel: "Exportar Excel",
      fire_smoke: {
        option: "Reporte de fuego y humo",
        modal_title: "Exportar reporte de fuego y humo",
        date_range: "Rango de fechas",
        export: "Exportar",
        cancel: "Cancelar",
        select_range: "Selecciona un rango de fechas",
        export_error: "Error exportando el reporte de fuego y humo",
      },
    },
  };
  